import { useState } from "react";
import "./featured.css";
import { useNavigate } from "react-router-dom";

const Featured = () => {
  const navigate = useNavigate();
   const [destination, setDestination] = useState("");
    const [date, setDate] = useState([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
      const [options, setOptions] = useState({
        adult: 1,
        children: 0,
        room: 1,
      });
  return (
    <div className="featured">
      <div className="featurescroll" onClick={()=>navigate('/hotels', { state: { destination, date, options } })}>
      <div className="featuredItem">
          <img
            src="https://salviatravelsindia.com/wp-content/uploads/2020/10/minsk-wooden-Holy-Trinity-Church.jpg"
            alt="" className="featuredImg"/>
          <div className="featuredTitles">
            <h1>Belarus</h1>
            <h2>104 Locations</h2>
          </div>
        </div>

        <div className="featuredItem">
          <img
            src="https://cf.bstatic.com/xdata/images/city/max500/957801.webp?k=a969e39bcd40cdcc21786ba92826063e3cb09bf307bcfeac2aa392b838e9b7a5&o="
            alt="" className="featuredImg"/>
          <div className="featuredTitles">
            <h1>Switzerland</h1>
            <h2>123 Locations</h2>
          </div>
        </div>
      
      <div className="featuredItem">
        <img
          src="https://cf.bstatic.com/xdata/images/city/max500/690334.webp?k=b99df435f06a15a1568ddd5f55d239507c0156985577681ab91274f917af6dbb&o="
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Sweden</h1>
          <h2>150 Locations</h2>
        </div>
      </div>
      <div className="featuredItem">
        <img
          src="https://cf.bstatic.com/xdata/images/city/max500/689422.webp?k=2595c93e7e067b9ba95f90713f80ba6e5fa88a66e6e55600bd27a5128808fdf2&o="
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Denmark</h1>
          <h2>97 Locations</h2>
        </div>
      </div>

      <div className="featuredItem">
        <img
          src="https://cf.bstatic.com/xdata/images/city/max500/689422.webp?k=2595c93e7e067b9ba95f90713f80ba6e5fa88a66e6e55600bd27a5128808fdf2&o="
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>The UK</h1>
          <h2>129 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://www.onthegotours.com/repository/Japan-homepage-carousel-image--Mt-Fuji-landscape--On-The-Go-Tours-658901536311885_crop_800_600.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Japan</h1>
          <h2>200 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://media.tacdn.com/media/attractions-splice-spp-674x446/07/3d/9f/2d.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Singapore</h1>
          <h2>48 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://media.tacdn.com/media/attractions-splice-spp-674x446/0b/e2/b1/fe.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Luxembourg</h1>
          <h2>156 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://www.shamrockeradventures.com/media/16681/ballintoy-northern-ireland-tours.jpg?anchor=center&mode=crop&quality=20&width=800&height=600&rnd=132255669160000000"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Ireland</h1>
          <h2>148 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://cdn.holidaytravel.co/uploaded_files/destination_img/2016_11580f1cc3def3ebermuda-tourist-guide-qpr.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Bermuda</h1>
          <h2>236 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://www.fjordtours.com/media/10291/vision_of_the_fjords_on_board_-sverre_hjornevikcom_fla-m.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Norway</h1>
          <h2>127 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://img.traveltriangle.com/attachments/pictures/1090880/original/Adventurous_man_at_Godafoss_on_Iceland.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Iceland</h1>
          <h2>189 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://img.traveltriangle.com/attachments/pictures/895190/original/charlotte-north-carolina-skyline.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>USA</h1>
          <h2>350 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://www.jaisuntourism.com/images/australia-tour-package-from-coimbatore.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Australia</h1>
          <h2>189 Locations</h2>
        </div>
      </div>


      <div className="featuredItem">
        <img
          src="https://static.independent.co.uk/2022/08/30/13/iStock-639156926.jpg"
          alt=""
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Israel</h1>
          <h2>177 Locations</h2>
        </div>
      </div>

</div>
    </div>
  );
};

export default Featured;
